export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11403.cf3b756c.jpg";